module.exports = __webpack_public_path__ + "img/paragraph-wrap.b64f15e2.svg";